export enum AustralianState {
  NSW = 'NSW',
  VIC = 'VIC',
  WA = 'WA',
  NT = 'NT',
  TAS = 'TAS',
  QLD = 'QLD',
  SA = 'SA',
  ACT = 'ACT',
}

export type Address = {
  address: string;
  addressLine1: string;
  addressLine2: string;
  gnaf: string;
  houseNo: string;
  latitude: number;
  longitude: number;
  postcode: string;
  state: AustralianState;
  streetName: string;
  suburb: string;
  unitNo?: string;
  lotNo?: string; // Possibly not returned from search?
  streetPrefix?: string; // Possibly not returned from search?
  streetSuffix?: string; // Possibly not returned from search?
};

export type PostalAddress = {
  address: string;
  addressLine1: string;
  addressLine2: string;
  gnaf?: string;
  houseNo?: string;
  latitude?: number;
  longitude?: number;
  lotNo?: string;
  postcode: string;
  state: AustralianState;
  streetName?: string;
  streetPrefix?: string;
  streetSuffix?: string;
  suburb: string;
  unitNo?: string;
};

export type LocalityAddress = {
  address: string;
  addressLine1: string;
  addressLine2: string;
  postcode: string;
  state: AustralianState;
  suburb: string;
};
